import Route from 'cio/routes/base';

export default class AccountApiCredentialsConfirmDeleteRedirectRoute extends Route {
  redirect({ id }) {
    this.router.replaceWith('settings.api_credentials.confirm_delete', id);
  }
}
